import { handleNYCase } from "./handleNYCase.js";
import { getValidationReason } from "./getValidationReason.js";
import { formatPostalCode } from "./formatPostalCode.js";
const isValidateAddressProps = (d) => "streetAddress" in d, validateAddress__ = (result) => {
  let city = "", state = "", postalCode = "", country = "";
  const streetAddressData = {
    streetAddress: ""
  };
  if (isValidateAddressProps(result))
    streetAddressData.streetAddress = result.streetAddress, city = result.city, state = result.state, postalCode = formatPostalCode(result.postalCode), country = result.country;
  else {
    const { neighborhood, city: _city, borough, route, streetNumber } = result;
    city = handleNYCase({ state: result.state, borough, neighborhood }) ?? _city, streetAddressData.streetAddress = streetNumber && route ? result.address1 ?? "" : void 0, streetAddressData.route = result.route ?? void 0, streetAddressData.streetNumber = result.streetNumber ?? void 0, state = result.state, postalCode = result.formattedPostalCode, country = result.country;
  }
  const isValid = !!streetAddressData.streetAddress && !!city && !!state && !!postalCode && country === "US";
  return isValid ? {
    isValid
  } : {
    isValid,
    reason: getValidationReason({ city, state, postalCode, country, ...streetAddressData })
  };
};
export {
  isValidateAddressProps,
  validateAddress__
};
//# sourceMappingURL=validateAddress__.js.map
